import React, { useState, useEffect , useRef } from 'react';
import {getSeries, addSerie, updateSerie, eliminarSerie } from '../api/seriesService';
import {getUnidadesMedidas, addUnidadMedida,updateUnidadMedida, eliminarUnidadMedida, getNumeroNexUnidadMedida} from '../api/unidadMedidaService'
import {getEmpresa, updateEmpresa} from '../api/empresaService';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { Toolbar } from 'primereact/toolbar';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { InputText } from 'primereact/inputtext';
import { classNames } from 'primereact/utils';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { Card } from 'react-bootstrap';
import { RadioButton } from 'primereact/radiobutton';
import { Tag } from 'primereact/tag';
import { InputNumber } from 'primereact/inputnumber';
import { InputTextarea } from 'primereact/inputtextarea';
import { getMonedas} from '../api/monedaFormaPagoService';

function MainConfiguracion() {

let emptySeries={
_id:null,
    noSerie:null,
    alias:'',
    serie:'',
    ultimoFolio:null,
    estado:null,
    tipo:'',
    diseno:''
};
let emptyEmpresa={
    _id:null,
    razonSocial:'',
    rfc:'',
    regimenFiscal:'',
    correo:'',
    moneda:'', 

    direccion: {            
            calle:'',
            cp:'',                
            municipio:'',
            estado:'',
            pais:'',
            telefono:''
    },
    logo: null // 👈 nuevo
};

let emptyMedidas={
    _id:null,
    noUnidad:null,
    nombre:"",
    descripcion:"",
    tipoMedida:"",
    Clasificacion:"",
    abreviatura:"",
};

const [series, setSeries] = useState([]);
const [serie, setSerie] = useState(emptySeries);

const [serieDialog, setSerieDialog] = useState(false);

const [deleteSerieDialog, setDeleteSerieDialog] = useState(false);

const [submitted, setSubmitted] = useState(false);
//Medidas
const [medidas, setMedidas] = useState([]);
const [medida, setMedida] = useState(emptyMedidas);

const [medidasDialog, setMedidaDialog] = useState(false);

const [deleteMeidaDialog, setDeleteMedidaDialog] = useState(false);

const toast = useRef(null);
const dt = useRef(null);
const dtMedidas = useRef(null);

const tipoSeries = [{name:'Ingreso', code:'I' },{name:'Egreso', code:'E'},{name:'Pago', code:'P'}];
const estados=[{name:'Activo', code:'1'},{name:'Inactivo', code:'0'}];

//empresa
const [empresa , setEmpresa]=useState([]);
const [submittedEmpresa, setSubmittedEmpresa] = useState(false);

const [tipoMedida, setTipoMedida] = useState('');
const [tipoClasificacion, setTipoClasificacion] = useState('');
const [esNuevoMedida, setEsNuevoMedida] = useState(true); 

const [monedaSeleccionado, setMonedaSeleccionado] = useState(null); // producto del dropdown7
const [monedas, setMonedas] = useState([]);
const [moneda, setMoneda] = useState(null);

useEffect(() => {
    const fetchData = async () => {
        const data = await getEmpresa();
        
        if (data && data.length > 0) {
        setEmpresa(data[0]); // Tomamos solo el primer (y único) documento
    }
    };
    fetchData();
    }, []);
   
useEffect(() => {
    const fetchData = async () => setSeries(await getSeries());
    fetchData();
}, []);

useEffect(() => {
    const fetchData = async () =>setMedidas(await getUnidadesMedidas());
    fetchData();
}, []);

const onEmpresaChange = (e, field, subfield = null) => {
    let _empresa = { ...empresa };
    if (subfield) {
        _empresa.direccion[subfield] = e.target.value;
    } else {
        _empresa[field] = e.target.value;
    }
    setEmpresa(_empresa);
};
// Cargar monedas al inicio
useEffect(() => {
    const fetchMonedas = async () =>setMonedas(await getMonedas()) ;
    fetchMonedas();
}, []);

useEffect(() => {
    if (monedas.length > 0 && empresa?.moneda) {
        const monedaInicial = monedas.find(
            (m) => m.codigo === empresa.moneda
        );
        if (monedaInicial) {
            setMoneda(monedaInicial);
        }
    }
}, [monedas, empresa]);

// logo
const onLogoChange = (e) => {
    const file = e.target.files[0];
  if (file) {
    const reader = new FileReader();
    reader.onloadend = () => {
      setEmpresa({ ...empresa, logo: reader.result }); // guarda base64
    };
    reader.readAsDataURL(file);
  }
};

const openNew =  () => {
    setSerie(emptySeries);
    setSubmitted(false);
    setSerieDialog(true);  
};

const openMedidasNew =async () => {
    setMedida(emptyMedidas);//emptySeries
    setSubmitted(false);
    setMedidaDialog(true);

    setEsNuevoMedida(true);
 try{
        const data = await getNumeroNexUnidadMedida();  // consulta al backend
        setMedida((prev) => ({ ...prev, noUnidad: data.unidadMedidaId })); // asigna el noCliente
      console.log(data);
      setMedidaDialog(true);
        }
        catch(error)
        {
            toast.current.show({
            severity: "error",
            summary: "Error",
            detail: "No se pudo generar el número de cliente",
            life: 3000,
        });
        }
};
    
    /*Guardar Serie*/
const saveSerie = async () => {
    setSubmitted(true);

    if (serie.alias && serie.serie) {        
    try{
            let _series = [...series];
        let _serie = { ...serie };

        if (serie._id) {
            // aquí irá el código de actualización más adelante
            console.log(serie);
            const updated = await updateSerie(_serie._id, _serie);
            const index = findIndexById(_serie._id);
            _series[index] = updated;
        } else {
            const inserted = await addSerie(_serie);
            _series.push(inserted);
        }
    const dataActualizada = await getSeries();   
    setSeries(dataActualizada);
    setSerieDialog(false);
    setSerie(emptySeries);
    toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Serie guardada', life: 3000 });

    }
    catch (error) {
    console.error('Error al guardar serie:', error);
    toast.current.show({ severity: 'error', summary: 'Error', detail: 'No se pudo guardar la serie', life: 3000 });

    }
}
};


const saveMedida = async () => {
        setSubmitted(true);

        if(medida.noUnidad && medida.nombre  ){             
        try{
            let _medidas = [...medidas];
            let _medida = { ...medida };
            _medida.tipoMedida=tipoMedida;
            _medida.Clasificacion=tipoClasificacion;

            if (medida._id) {
                //aquí irá el código de actualización más adelante
            
                const updated = await updateUnidadMedida(_medida._id, _medida);
                const index = findIndexById(_medida._id);
                _medidas[index] = updated;
            } else {
               const inserted = await addUnidadMedida(_medida);
                _medidas.push(inserted);
            }
        const dataActualizada = await getUnidadesMedidas(); 
        setMedidas(dataActualizada) ;
        setMedidaDialog(false);
        setMedida(emptyMedidas);
        toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Unidad de medida guardada', life: 3000 });
        }
        catch (error) {
       //console.error(error.response.data.error);
      toast.current.show({ severity: 'error', summary: 'Error', detail: error.response.data.error, life: 3000 });
        }
    }
};

const editSerie = (serie) => {
        setSerie({ ...serie });// importante conservar el _id
        setSerieDialog(true);
    };

const editMedida = (medida) => {
        setMedida({ ...medida });// importante conservar el _id
        setMedidaDialog(true);
        setEsNuevoMedida(false);
    };

const confirmDeleteSerie = (serie) => {

    console.log(serie);
       
        confirmDialog({
            message: `¿Deseas eliminar la serie?`,
            header: 'Confirmar eliminación',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: 'Sí, eliminar',
            rejectLabel: 'Cancelar',
            acceptClassName: 'p-button-danger',
            rejectClassName: 'p-button-secondary',
           
            accept: async () => {
    try {
        await eliminarSerie(serie._id); // 👈 Espera a que se elimine en el backend
        const dataActualizada = await getSeries(); // 👈 Recarga lista desde la BD
        setSeries(dataActualizada);
        setSerie(emptySeries);

        toast.current?.show({
            severity: 'success',
            summary: 'Eliminado',
            detail: 'Serie eliminada correctamente',
            life: 3000,
        });
    } catch (error) {
        console.error("Error al eliminar serie:", error);
        toast.current?.show({
            severity: 'error',
            summary: 'Error',
            detail: 'No se pudo eliminar la serie',
            life: 3000,
        });
    }
},
          
          });
    };
    
const confirmDeleteMedidas = (medida) => {

    //console.log(medida);
       
        confirmDialog({
            message: `¿Deseas eliminar la unidad de medida?`,
            header: 'Confirmar eliminación',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: 'Sí, eliminar',
            rejectLabel: 'Cancelar',
            acceptClassName: 'p-button-danger',
            rejectClassName: 'p-button-secondary',
           
            accept: async () => {
    try {
        await eliminarUnidadMedida(medida._id); // 👈 Espera a que se elimine en el backend
        const dataActualizada = await getUnidadesMedidas(); // 👈 Recarga lista desde la BD
        
        setMedidas(dataActualizada);
        setMedida(emptyMedidas);

        toast.current?.show({
            severity: 'success',
            summary: 'Eliminado',
            detail: 'Serie eliminada correctamente',
            life: 3000,
        });
    } catch (error) {
        console.error("Error al eliminar serie:", error);
        toast.current?.show({
            severity: 'error',
            summary: 'Error',
            detail: 'No se pudo eliminar la serie',
            life: 3000,
        });
    }
},
          
          });
    };


const hideDialog = () => {
    setSubmitted(false);
    setSerieDialog(false);
};
const medidahideDialog = () => {
        setSubmitted(false);
        setMedidaDialog(false);
    };
const exportCSV = () => {
        dt.current.exportCSV();
    };

const exportCSVMedidas = () => {
        dtMedidas.current.exportCSV();
    };


const onInputChange = (e, name) => {
        // const val = (e.target && e.target.value) || '';
        // let _serie = { ...serie };

        // _serie[`${name}`] = val;
        const val = (e.value !== undefined) ? e.value : (e.target ? e.target.value : '');

        //setSerie(_serie);
        setSerie((prevSerie) => ({ ...prevSerie, [name]: val }));
    };

const onInputChangeMedidas = (e, name) => {
         // Para InputText, InputNumber, etc.
    const val = (e.value !== undefined) ? e.value : (e.target ? e.target.value : '');
        let _medida = { ...medida };

        //_medida[`${name}`] = val;
         _medida[name] = val;
        //console.log(_medida);
        setMedida(_medida);
    };

const findIndexById = (_id) => {
    return series.findIndex((c) => c._id === _id);
        };

const saveEmpresa = async () => {
    setSubmittedEmpresa(true);
    //console.log(moneda);
//console.log(moneda.codigo);
    try {
    const empresaData = {
    razonSocial: empresa.razonSocial,
    rfc: empresa.rfc,
    regimenFiscal: empresa.regimenFiscal,
    correo: empresa.correo,
    moneda:moneda.codigo,
    tipoCambioDolares: empresa.tipoCambioDolares,
    direccion:{
        calle: empresa.direccion.calle,
        cp: empresa.direccion.cp,
        municipio: empresa.direccion.municipio,
        estado: empresa.direccion.estado,
        pais: empresa.direccion.pais,
        telefono: empresa.direccion.telefono
    },
    logo: empresa.logo || null, // si manejas logo en base64 o URL    
    };
//console.log(empresaData);
    // Guardamos en MongoDB
    const updated = await updateEmpresa(empresa._id, empresaData);

    setEmpresa(updated);
    const data = await getEmpresa();
    if (data && data.length > 0) {
    setEmpresa(data[0]); // Tomamos solo el primer (y único) documento
    }
    toast.current.show({
      severity: 'success',
      summary: 'Éxito',
      detail: 'Datos actualizados',
      life: 3000
    });
    } catch (error) {
        console.error("Error al actualizar empresa:", error);
        toast.current.show({
      severity: 'error',
      summary: 'Error',
      detail: 'No se pudo actualizar la empresa',
      life: 3000
    });
    }
    //setMonedaSeleccionado(null);
};

const leftToolbarTemplate = () => {
    return (
        <div className="flex flex-wrap gap-2">
            <Button label="Agregar Serie" icon="pi pi-plus" severity="success" onClick={openNew} /> 
            <Button label="Exportar" icon="pi pi-upload" className="p-button-help" onClick={exportCSV}/>
        </div>
        );
};
const leftToolbarTemplateUniMedidas = () => {
    return (
        <div className="flex flex-wrap gap-2">
            <Button label="Unidad Medida" icon="pi pi-plus" severity="success" onClick={openMedidasNew} /> 
            <Button label="Exportar" icon="pi pi-upload" className="p-button-help" onClick={exportCSVMedidas}/>
        </div>
    );
};

const actionBodyTemplate = (rowData) => {
    return (
        <React.Fragment>
            <Button icon="pi pi-pencil" rounded  className="mr-2" onClick={() => editSerie(rowData)} />
            <Button icon="pi pi-trash" rounded  severity="danger" onClick={() => confirmDeleteSerie(rowData)} />
        </React.Fragment>
    );
};
const actionMedidaBodyTemplate = (rowData) => {
    return (
        <React.Fragment>
            <Button icon="pi pi-pencil" rounded  className="mr-2" onClick={() => editMedida(rowData)} />
            <Button icon="pi pi-trash" rounded  severity="danger" onClick={() => confirmDeleteMedidas(rowData)} />
        </React.Fragment>
    );
};
//editMedida
const serieDialogFooter = (
    <React.Fragment>
        <Button label="Cancelar" icon="pi pi-times" severity='danger'  onClick={hideDialog} />
        <Button label="Guardar" icon="pi pi-check" severity='success' onClick={saveSerie} />
    </React.Fragment>
);

const medidaDialogFooter = (
    <React.Fragment>
        <Button label="Cancelar" icon="pi pi-times" severity='danger' onClick={medidahideDialog} />
        <Button label="Guardar" icon="pi pi-check" severity='success' onClick={saveMedida} />
    </React.Fragment>
)
   const statusBodyTemplate = (rowData) => {
        return <Tag severity={rowData.estado ? "success" : "danger" } >
            {rowData.estado ? "Activo" : "Inactivo"}
            </Tag>;
    };

const statusBodyTemplateMedida = (rowData) => {
    const tipoMap = {
    
        Servicio: { severity: "info", label: "Servicio" },
        Producto: { severity: "warning", label: "Producto" }
    };
console.log(rowData.Clasificacion);
    const { severity, label } = tipoMap[rowData.Clasificacion] || { severity: "danger", label: "Desconocido" };

    return <Tag severity={severity} value={label} rounded />;
        };

    return (
        <>
    <Toast ref={toast} />
    <ConfirmDialog />
    <section className="mission-section" id="productosServicios">
        
        <div class="layout-content-inner">
            <div>
                <nav class="layout-breadcrumb">
                    <ol>
                        <li><a href="/"><i class="pi pi-home"></i></a></li>
                        <li class="layout-breadcrumb-chevron"> / </li>
                        <li>Configuracion</li>
                    </ol>
                </nav>
            </div>

             <div className="card">
                
            <Toolbar className="mb-4" aria-label="Actions">Mis Datos</Toolbar>
            
            <Accordion multiple activeIndex={[0]}>
                <AccordionTab header="Datos Fiscales">
                    {empresa ? (
                                    <div className="p-fluid formgrid grid">
                                        <div className="field col-12 md:col-6">
                                             <label htmlFor="razonSocial"><strong>Razón Social</strong></label>
                                            <InputText disabled id="razonSocial" value={empresa.razonSocial} onChange={(e) => onEmpresaChange(e, 'razonSocial')} />
                                        </div>
                                        <div className="field col-12 md:col-3">
                                            <label htmlFor="rfc"><strong>RFC</strong></label>
                                            <InputText disabled id="rfc" value={empresa.rfc} onChange={(e) => onEmpresaChange(e, 'rfc')} />
                                        </div>
                                        <div className="field col-12 md:col-3">
                                            <label htmlFor="regimenFiscal"><strong>Regimen Fiscal</strong></label>
                                            <InputText id="regimenFiscal" value={empresa.regimenFiscal} onChange={(e) => onEmpresaChange(e, 'regimenFiscal')} />
                                        </div>
                                        <div className="field col-12 md:col-6">
                                            <label htmlFor="correo"><strong>Correo</strong></label>
                                            <InputText id="correo" value={empresa.correo} onChange={(e) => onEmpresaChange(e, 'correo')} />
                                        </div>
                                        <div className="field col-12 md:col-3">
                                        <label htmlFor="moneda"><strong>Moneda</strong></label>
                                        
                                        <Dropdown id="idMoneda"  value={moneda} 
                                        onChange={(e) => setMoneda(e.value)}
                                        options={monedas}                                        
                                        placeholder="Seleccione" className="w-full md:w-300rem" optionLabel="moneda"  
                                        itemTemplate={(option) => `${option.codigo} - ${option.moneda}`}
                                        valueTemplate={(option, props) => option ? `${option.codigo} - ${option.moneda}` : props.placeholder}/>
                                        </div> 
                                            <div className="field col-12 md:col-3">
                                            <label htmlFor="moneda"><strong>Tipo de cambio en Dolar</strong></label>
                                            <InputText id="correo" value={empresa.tipoCambioDolares} onChange={(e) => onEmpresaChange(e, 'tipoCambioDolares')}/>
                                            </div>       
                                        
                                    </div>
                                ) : (
                                    <p>Cargando datos fiscales...</p>
                                )}
                </AccordionTab>
                <AccordionTab header="Direccion">
                     {empresa ? (
                         empresa.direccion ? (
                              
                        <div className="p-fluid formgrid grid">
                            <div className="field col-12 md:col-12">
                            <label htmlFor="calle" ><strong>Calle</strong></label>
                                <InputText id="calle" value={empresa.direccion.calle} onChange={(e) => onEmpresaChange(e,'direccion' ,'calle')} />
                            </div>
                            <div className="field col-12 md:col-1">
                            <label htmlFor="cp" ><strong>CP</strong></label>
                                <InputText id="cp" value={empresa.direccion.cp} onChange={(e) => onEmpresaChange(e,'direccion', 'cp')} />
                            </div>
                            <div className="field col-12 md:col-2">
                            <label htmlFor="municipio" ><strong>Municipio</strong></label>
                                <InputText id="municipio" value={empresa.direccion.municipio} onChange={(e) => onEmpresaChange(e,'direccion' , 'municipio')} />
                            </div>
                            <div className="field col-12 md:col-2">
                            <label htmlFor="estado" ><strong>Estado</strong></label>
                                <InputText id="estado" value={empresa.direccion.estado} onChange={(e) => onEmpresaChange(e,'direccion' , 'estado')} />
                            </div>
                            <div className="field col-12 md:col-2">
                            <label htmlFor="pais" ><strong>País</strong></label>
                                <InputText id="pais" value={empresa.direccion.pais} onChange={(e) => onEmpresaChange(e,'direccion' , 'pais')} />
                            </div> 
                            <div className="field col-12 md:col-2">
                            <label htmlFor="telefono" ><strong>Teléfono</strong></label>
                                <InputText id="telefono" value={empresa.direccion.telefono} onChange={(e) => onEmpresaChange(e,'direccion' , 'telefono')} />
                            </div>   
                        </div>
                      ) : (
                        <p>La dirección no está disponible.</p>
                        )
                    ) : (
                        <p>Cargando dirección...</p>
                    )}
                    </AccordionTab>
                <AccordionTab header="Parametros">
                     <div className="field col-24 md:col-5">
                        {/* <label htmlFor="logo">Logo</label> */}
                        <Card >
                            
                        <div className={` flex  bg-cyan-50`}>
                                   
                        <h5></h5>
                        <input type="file" accept="image/*" onChange={onLogoChange}     />
                        
                        <h5> </h5>
                        
                        <img src={empresa.logo} alt="Logo" style={{ width: "120px", marginTop: "10px" }} />
                         </div>
                    </Card>
                    
                    </div>
                </AccordionTab>
                
            </Accordion>
        <div className="col-12">
                <Button label="Guardar Empresa" icon="pi pi-check" onClick={saveEmpresa} />
            </div>
        </div>
        
        <div className="card">
            <Toolbar className="mb-4" aria-label="Actions">Mis Datos</Toolbar>
              <Accordion multiple >
                
                <AccordionTab header="Series/Documentos">

                    <Toolbar className="mb-4" right={leftToolbarTemplate} ></Toolbar>
                    <DataTable   ref={dt} value={series}  paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]} tableStyle={{ minWidth: '50rem' }}>
                        <Column field="noSerie" header="#"></Column>
                        <Column field="alias" header="Alias"></Column>
                        <Column field="serie" header="Serie"></Column>
                        <Column field="ultimoFolio" header="Ultimo Folio"></Column>   
                        {/* <Column field="diseno" header="Formato"></Column>                    */}
                        <Column field="tipo" header="Tipo Comprobante"></Column>
                        <Column field="estado" header="Estado" body={statusBodyTemplate}></Column>

                        <Column  header="Acciones" body={actionBodyTemplate}  exportable={false} style={{ minWidth: '5rem' }}></Column>
                       
                    </DataTable>
                </AccordionTab>
            </Accordion>
        </div>
        <div className="card">
              <Toolbar className="mb-4" aria-label="Actions"></Toolbar>
              <Accordion multiple >
                {/* activeIndex={[0]} */}
                <AccordionTab header="Unidades de Medidas">
                <Toolbar className="mb-4" right={leftToolbarTemplateUniMedidas } ></Toolbar>
                    <DataTable  ref={dtMedidas} value={medidas}  paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]} tableStyle={{ minWidth: '50rem' }}>
                        <Column field="noUnidad" header="# Medida"></Column> 
                        <Column field="nombre" header="Nombre" ></Column>
                        {/* <Column field="abreviatura" header="Tipo" body={statusBodyTemplateMedida}></Column> */}
                        <Column field="abreviatura" header="Abreviatura"></Column>
                        
                         <Column  header="Acciones" body={actionMedidaBodyTemplate}  exportable={false} style={{ minWidth: '5rem' }}></Column>
                       
                    </DataTable>
                </AccordionTab>
            </Accordion>

        </div>

<Dialog visible={serieDialog} style={{ width: '32rem' }} breakpoints={{ '960px': '75vw', '641px': '90vw' }} header="Nueva Serie" modal className="p-fluid" footer={serieDialogFooter} onHide={hideDialog}>
<div className="formgrid grid">
    <div className="field col">
        <label htmlFor="alias" className="font-bold">
            Alias
        </label>
        <InputText id="alias" value={serie.alias} onChange={(e) => onInputChange(e, 'alias')} required autoFocus className={classNames({ 'p-invalid': submitted && !serie.alias})} />
        {submitted && !serie.alias && <small className="p-error">El alias es requerido.</small>}
    </div>
                        
    <div className="field col-3">
        <label htmlFor="serie" className="font-bold">
            Serie
        </label>
        <InputText id="serie" value={serie.serie} onChange={(e) => onInputChange(e, 'serie')} required rows={3} cols={20} />
    </div>
</div>        
 <div className="formgrid grid">
    <div className="field col-4">
        <label htmlFor="ultimoFolio" className="font-bold">
            Folio consecutivo
        </label>
        <InputNumber id="ultimoFolio" value={serie.ultimoFolio} onChange={(e) => onInputChange({ value: e.value }, 'ultimoFolio')} required rows={3} cols={20} />
    </div>
    <div className="field col-4 ">
        <label htmlFor="tipo" className="font-bold">                 Tipo</label>
        
        <Dropdown id="tipo" value={serie.tipo} onChange={(e) => onInputChange({ target: { value: e.value } }, 'tipo')} options={tipoSeries}
            optionLabel="name" placeholder="Seleccione un tipo"  optionValue="name" dataKey="name"
            className={classNames({ 'p-invalid': submitted && !serie.tipo })}
        />
            {submitted && !serie.tipo && <small className="p-error">el tipo es requerido.</small>}
    </div>
    <div className="field">
    {/* <label htmlFor="estado" className="font-bold">
        Estado
    </label> */}
    {/* <Dropdown id="estado" value={serie.estado} onChange={(e) => onInputChange({ target: { value: e.value } }, 'estado')} options={estados}
        optionLabel="name"  placeholder="Seleccione un estado"   optionValue="name"
            dataKey="name"
        className={classNames({ 'p-invalid': submitted && !serie.estado })}/> */}
         <label htmlFor="estado" className="font-bold">
                        Estado
                    </label>
                     <div className="flex flex-wrap gap-3">
                         <div className="flex align-items-right">
                              <input type="checkbox" name="estado"  onChange={(e) => onInputChange({ target: { value: e.target.checked } }, 'estado')} checked={serie.estado || false} />
                                <label htmlFor="estado" className="ml-2">Activo</label>
                     </div>
                     </div>
    </div>

</div>                       
        
                        
</Dialog>

<Dialog visible={medidasDialog}style={{ width: '38rem' }} breakpoints={{ '960px': '75vw', '641px': '90vw' }} header="Unidad de medida" modal className="p-fluid" footer={medidaDialogFooter} onHide={medidahideDialog} >
{/* <div className="card  flex  gap-3">
    <div className="field ">
        <label htmlFor="tipo1" className="ml-2"><strong>Tipo </strong> </label>
    </div>
     
<div className="flex align-items-center">
        <RadioButton inputId="tipoClasificacion1" name="servicio" value="Servicio" onChange={(e) => setTipoClasificacion(e.value)} checked={tipoClasificacion === 'Servicio'} />
        <label htmlFor="tipoClasificacion1" className="ml-2">Servicio</label>
    </div>
    <div className="flex align-items-center">
        <RadioButton inputId="tipoClasificacion2" name="producto" value="Producto" onChange={(e) => setTipoClasificacion(e.value)} checked={tipoClasificacion === 'Producto'} />
        <label htmlFor="tipoClasificacion2" className="ml-2">Producto</label>
    </div>
</div> */}
<div className="formgrid grid">
    <div className="field col-3">
        <label htmlFor="noUnidad" className="font-bold"  > #Unidad  </label>
        <InputNumber id="noUnidad" value={medida.noUnidad} onChange={(e) => onInputChangeMedidas(e, 'noUnidad') }  
         disabled={!esNuevoMedida} 
            required autoFocus className={classNames({ 'p-invalid': submitted && ! medida.noUnidad})} /> 
            {submitted && !medida.noUnidad && <small className="p-error">Es necesario el numero de unidad</small>}        
    </div>
    <div className="field col">
       <label htmlFor="nombre" className="font-bold"> Nombre </label>
            <InputText id="nombre" value={medida.nombre} onChange={(e) => onInputChangeMedidas(e, 'nombre')} required autoFocus className={classNames({ 'p-invalid': submitted && !medida.nombre})} />
            {submitted && !medida.nombre && <small className="p-error">La nombre es requerido.</small>}        
    </div>
    <div className="field col-2">
       <label htmlFor="abreviatura" className="font-bold"> Abreviatura </label>
            <InputText id="abreviatura" value={medida.abreviatura} onChange={(e) => onInputChangeMedidas(e, 'abreviatura')} required autoFocus className={classNames({ 'p-invalid': submitted && !medida.abreviatura})} />
            {submitted && !medida.abreviatura && <small className="p-error"></small>}        
    </div>

</div>
<div className="formgrid grid">
    <div className="field col">
        <label htmlFor="descripcion" className="font-bold"> Descripcion </label>
            <InputTextarea id="descripcion" value={medida.descripcion} onChange={(e) => onInputChangeMedidas(e, 'descripcion')} required  />
            {/* {submitted && !medida.decripcion && <small className="p-error">La descripcion es requerida.</small>}         */}
    </div>
</div>
{/* <div>
     <label htmlFor="tipo1" className="ml-2"><strong>Tipo medida</strong> </label>
</div>
<div className="card  flex  gap-3">
   
    <div className="flex align-items-center">
        <RadioButton inputId="tipo1" name="cantidad" value="cantidad" onChange={(e) => setTipoMedida(e.value)} checked={tipoMedida === 'cantidad'} />
        <label htmlFor="tipo1" className="ml-2">Cantidad</label>
    </div>
    <div className="flex align-items-center">
        <RadioButton inputId="tipo2" name="largo" value="largo" onChange={(e) => setTipoMedida(e.value)} checked={tipoMedida === 'largo'} />
        <label htmlFor="tipo2" className="ml-2">Largo</label>
    </div>
    <div className="flex align-items-center">
        <RadioButton inputId="tipo3" name="peso" value="peso" onChange={(e) => setTipoMedida(e.value)} checked={tipoMedida === 'peso'} />
        <label htmlFor="tipo3" className="ml-2">Peso</label>
    </div>   
</div>     */}
</Dialog>
                     

    </div>
    </section>
        </>
      
    );
}
export default MainConfiguracion;      